import { QuyHoachActionType } from './quyhoach.action-types';
import { QuyHoachAction } from './quyhoach.action-rule';
import ThongTinDoAn, { DM_TTDA_LoaiQuyHoach, DM_TTDA_TrangThaiPheDuyetQuyHoach, DoAnQuyHoach } from './models/ranhgioiquyhoach.model';
import { NoiDungGopY } from './models/danhmuchoso.model';

import { AuthActionType } from '../../main/main.action-types';
import MainAction from '../../main/main.action-rule';
import { File } from '../quan-ly-quy-hoach/models/luutruquyhoach.model';
import { QuanHuyen } from '../models/HanhChinh';

export type Model = {
  hanhChinhSelected?: QuanHuyen,
  giaiDoan?: DM_TTDA_TrangThaiPheDuyetQuyHoach,
  doAnQuyHoachs?: Array<DoAnQuyHoach>,
  doAnSelected?: ThongTinDoAn,
  noiDungGopYs?: NoiDungGopY[],
  tepDinhKemFolderFileId?: File
};

export const defaultState: Model = {
};

function reducer(state: Model = defaultState, action: QuyHoachAction | MainAction): Model {
  switch (action.type) {
    case QuyHoachActionType.ChonGiaiDoan:
      return {
        ...state,
        giaiDoan: action.giaiDoan,
        doAnQuyHoachs: [
          {
            loaiQuyHoach: DM_TTDA_LoaiQuyHoach["QuyHoachChungTinh"],
            doAns: []
          }
        ],
        hanhChinhSelected: undefined,
        doAnSelected: undefined,
        tepDinhKemFolderFileId: undefined,
        noiDungGopYs: action.giaiDoan === DM_TTDA_TrangThaiPheDuyetQuyHoach["LayYKien"] ? [] : undefined
      }

    case QuyHoachActionType.ThongTinQuyHoach_ChonHanhChinh:
      let loaiQuyHoachs: DM_TTDA_LoaiQuyHoach[] = [
        DM_TTDA_LoaiQuyHoach["QuyHoachChungDoThi"],
      ]
      if (!action.hanhChinh) {
        loaiQuyHoachs = [];
      }
      // nếu không phải là thành phố thì có thêm quy hoạch nông thôn
      else {
        if (
          action.hanhChinh.maQuanHuyen === '689'

        ) {
          loaiQuyHoachs.push(DM_TTDA_LoaiQuyHoach.QuyHoachPhanKhu);
          loaiQuyHoachs.push(DM_TTDA_LoaiQuyHoach.QuyHoachNTM);
        }
        else loaiQuyHoachs.push(DM_TTDA_LoaiQuyHoach.QuyHoachNTM);
      }
      loaiQuyHoachs.push(DM_TTDA_LoaiQuyHoach["QuyHoachChiTiet"]);
      return {
        ...state,
        hanhChinhSelected: action.hanhChinh,
        doAnQuyHoachs: loaiQuyHoachs.map(m => ({ loaiQuyHoach: m, doAns: [] } as DoAnQuyHoach))
      }

    case QuyHoachActionType.ThongTinQuyHoach_ChonLoaiQuyHoach_SUCCESS:
      // thêm dữ liệu đồ án quy hoạch
      let doAnQuyHoachs = state.doAnQuyHoachs ? [...state.doAnQuyHoachs] : [];
      let doAnQuyHoach = doAnQuyHoachs.find(f => f.loaiQuyHoach === action.loaiQuyHoach);

      if (doAnQuyHoach) {
        doAnQuyHoach.doAns = action.quyHoachs;
      } else {
        doAnQuyHoach = { loaiQuyHoach: action.loaiQuyHoach, doAns: action.quyHoachs };
        doAnQuyHoachs.push(doAnQuyHoach);
      }

      return { ...state, doAnQuyHoachs };

    case QuyHoachActionType.ThongTinQuyHoach_TepDinhKem:
      return { ...state, tepDinhKemFolderFileId: action.file };
    case QuyHoachActionType.ThongTinQuyHoach_ChonQuyHoach:
      return { ...state, doAnSelected: action.rgqh, noiDungGopYs: state.giaiDoan === DM_TTDA_TrangThaiPheDuyetQuyHoach["LayYKien"] ? [] : undefined };

    case QuyHoachActionType.GopYQuyHoach_NhapNoiDungGopY:
      if (!state.noiDungGopYs && action.hoSo.ID)
        return state;
      let noiDungGopYs = state.noiDungGopYs ? [...state.noiDungGopYs] : [];

      let noiDungGopY = noiDungGopYs.find(f => f.hoSo.ID === action.hoSo.ID);
      // kiểm tra đã tồn tại hay chưa
      if (noiDungGopY) {
        noiDungGopY.noiDung = action.noiDung;
      } else {
        noiDungGopY = { hoSo: action.hoSo, noiDung: action.noiDung };
        noiDungGopYs.push(noiDungGopY);
      }
      return { ...state, noiDungGopYs };

    case AuthActionType.LOGOUT:
      return defaultState;
    default:
      return state;
  }
}

export default reducer;